import React from "react";
import { Svg, Path, SvgProps } from "react-native-svg";

export const WorkspacesIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <Path d="M6,13c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S8.2,13,6,13z M12,3C9.8,3,8,4.8,8,7s1.8,4,4,4s4-1.8,4-4S14.2,3,12,3z M18,13 c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S20.2,13,18,13z" />
  </Svg>
);

export const LocationIcon = (props: SvgProps) => {
  return (
    <Svg viewBox="0 0 64 64" {...props}>
      <Path d="M32 5.333C21.68 5.333 13.333 13.68 13.333 24 13.333 38 32 58.667 32 58.667S50.667 38 50.667 24C50.667 13.68 42.32 5.333 32 5.333zm0 25.334A6.67 6.67 0 0125.333 24 6.669 6.669 0 0132 17.333 6.67 6.67 0 0138.667 24 6.67 6.67 0 0132 30.667z" />
    </Svg>
  );
};

export const RainIcon = (props: SvgProps) => {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <Path d="M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8M7.83 14c.37 0 .67.26.74.62.41 2.22 2.28 2.98 3.64 2.87.43-.02.79.32.79.75 0 .4-.32.73-.72.75-2.13.13-4.62-1.09-5.19-4.12-.08-.45.28-.87.74-.87" />
    </Svg>
  );
};

export const WindIcon = (props: SvgProps) => {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <Path d="M14.5 17c0 1.65-1.35 3-3 3s-3-1.35-3-3h2c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1H2v-2h9.5c1.65 0 3 1.35 3 3M19 6.5C19 4.57 17.43 3 15.5 3S12 4.57 12 6.5h2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S16.33 8 15.5 8H2v2h13.5c1.93 0 3.5-1.57 3.5-3.5m-.5 4.5H2v2h16.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5v2c1.93 0 3.5-1.57 3.5-3.5S20.43 11 18.5 11" />
    </Svg>
  );
};

export const TemperatureIcon = (props: SvgProps) => {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <Path d="M15 13V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4m-4-8c0-.55.45-1 1-1s1 .45 1 1h-1v1h1v2h-1v1h1v2h-2z" />
    </Svg>
  );
};
